
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard/leaderboards",
      function () {
        return require("private-next-pages/dashboard/leaderboards/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dashboard/leaderboards"])
      });
    }
  